import {
  GET_EVENTS,
  GET_EVENT,
  POST_EVENT,
  UPDATE_EVENT,
  EVENT_ERROR,
  DELETE_EVENT
} from '../actions/types';

const initialState = {
  events: [],
  event: null,
  loading: true,
  error: {}
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_EVENTS:
      return {
        ...state,
        events: payload,
        loading: false
      };
    case GET_EVENT:
      return {
        ...state,
        event: payload,
        loading: false
      };
    default:
      return state;
  }
}
